const timers = {}

export default function(timerId, handler, timeout) {
  clearTimeout(timers[timerId])
  timers[timerId] = setTimeout(handler, timeout)
}
